<template>
  <div>
    <div class="card" id="printMe">
      <div class="card-header">
        <div class="row">
          <div class="col-sm-7">
            <h5 class="card-title">Mängel</h5>
          </div>
          <div class="col-sm-5 pt-1 pr-4 text-right">
            <p-button type="success" @click="newDefect()" title="Mangel anlegen" class="mt-0 mr-1 hidePrint" :disabled="constructionRole < 2"><i class="bi bi-plus-circle" style="font-size: 16px;"></i> Mangel anlegen</p-button>
            <p-button type="default" @click="downloadExcel()" title="Excel Export" class="mt-0 mr-1 hidePrint" :disabled="excelLoading"><i class="bi bi-file-earmark-excel" style="font-size: 16px;" v-if="!excelLoading"></i><i class="el-icon-loading" v-if="excelLoading"></i></p-button>
            <p-button type="default" v-print="'#printMe'" title="Liste drucken" class="mt-0 mr-0 hidePrint"><i class="bi bi-printer-fill" style="font-size: 16px;"></i></p-button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="defect-stats mb-4 pb-3 pt-2">
          <div class="defect-stat-item">
            <el-statistic title="Offen" :value=counterOpen group-separator="." :precision="0"></el-statistic>
          </div>
          <div class="defect-stat-item">
            <el-statistic title="Neu" :value=counterNew group-separator="." :precision="0"></el-statistic>
          </div>
          <div class="defect-stat-item">
            <el-statistic title="In Arbeit" :value=counterWIP group-separator="." :precision="0"></el-statistic>
          </div>
          <div class="defect-stat-item">
            <el-statistic title="Zur Abnahme" :value=counterInAcceptance group-separator="." :precision="0"></el-statistic>
          </div>
        </div>
        <div class="row mb-3 hidePrint">
          <div class="col-sm-4">
            <el-checkbox v-model="showCompleted">Erledigte Mängel anzeigen</el-checkbox>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <el-table 
            ref="defectTable"
            :data="filteredDefects"
            header-row-class-name="text-primary" empty-text="Es konnten keine Mängel gefunden werden."
              v-loading="loading"
              @row-click="showDetails"
              @filter-change="onFilterChange">
              <el-table-column prop="defectParcours" label="Parcours" min-width="150"
                column-key="parcours"
                :filters="parcoursFilters"
                :filter-method="filterParcours"
                :filtered-value="savedFilters.parcours"
                filter-placement="bottom-end"></el-table-column>
              <el-table-column prop="defectElement" label="Element" min-width="100"></el-table-column>
              <el-table-column prop="defectTitle" label="Titel" min-width="150">
                <template slot-scope="scope">
                  <span>{{ scope.row.defectTitle }}</span>
                  <el-tooltip v-if="scope.row.defectManagementNotes" placement="top" effect="dark">
                    <div slot="content" style="max-width: 300px; white-space: pre-line;">{{ scope.row.defectManagementNotes }}</div>
                    <i class="bi bi-chat-left-text-fill ml-2" style="color: #15a34a; cursor: help;"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="defectPrio" label="Priorität"
                column-key="prio"
                :filters="[{ text: 'Hoch', value: 'Hoch' }, { text: 'Mittel', value: 'Mittel'}, { text: 'Niedrig', value: 'Niedrig' }]"
                :filter-method="filterPrio"
                :filtered-value="savedFilters.prio"
                filter-placement="bottom-end"
                align="center"
                min-width="110">
                <template slot-scope="scope">
                  <el-tag
                    v-if="scope.row.defectPrio == 'Hoch'"
                    type="danger"
                    effect="plain"
                    disable-transitions>Hoch</el-tag>
                  <el-tag
                    v-if="scope.row.defectPrio == 'Mittel'"
                    type="warning"
                    effect="plain"
                    disable-transitions>Mittel</el-tag>
                  <el-tag
                    v-if="scope.row.defectPrio == 'Niedrig'"
                    type="info"
                    effect="plain"
                    disable-transitions>Niedrig</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="defectStatus" label="Status"
                column-key="status"
                :filters="[{ text: 'Neu', value: 'Neu' }, { text: 'In Arbeit', value: 'In Arbeit' }, { text: 'Zur Abnahme', value: 'Zur Abnahme' }, { text: 'Erledigt', value: 'Erledigt' }]"
                :filter-method="filterStatus"
                :filtered-value="savedFilters.status"
                filter-placement="bottom-end"
                align="center"
                min-width="100">
                <template slot-scope="scope">
                  <el-tag
                    v-if="scope.row.defectStatus === 'Erledigt'"
                    type="success"
                    disable-transitions>Erledigt</el-tag>
                  <el-tag
                    v-if="scope.row.defectStatus === 'Zur Abnahme'"
                    type="info"
                    disable-transitions>Zur Abnahme</el-tag>
                  <el-tag
                    v-if="scope.row.defectStatus === 'In Arbeit'"
                    type="warning"
                    disable-transitions>In Arbeit</el-tag>
                  <el-tag
                    v-if="scope.row.defectStatus === 'Neu'"
                    type="danger"
                    disable-transitions>Neu</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="defectDate" label="Datum" min-width="100"></el-table-column>
              <el-table-column prop="defectAssignedTo" label="Zugewiesen an" min-width="150"></el-table-column>
                <el-table-column label="Aufwand Soll/Ist" min-width="180">
                <template slot-scope="scope">
                  <span :style="{ color: scope.row.defectEffortActual > scope.row.defectEffort ? 'red' : 'inherit', fontWeight: scope.row.defectEffortActual > scope.row.defectEffort ? '600' : 'normal' }">
                  {{ scope.row.defectEffortTime }} / {{ scope.row.defectEffortActualTime }}
                  </span>
                </template>
                </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { db, fc } from "../../../../firebaseDb";
import { httpsCallable } from 'firebase/functions';
import { Table, TableColumn, Input, Loading, Popover, Tag, Select, Option, Statistic, MessageBox, Checkbox, Divider, Tooltip } from "element-ui";
import { Modal } from "src/components/UIComponents";
import moment from "moment-timezone";
import router from "../../../../main";
import store from "../../../../store";
import SelectLocation from '/src/components/KET/Views/Components/KETSelectLocation.vue'
import Print from 'vue-print-nb'
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Popover);
Vue.use(Loading);
Vue.use(Tag)
Vue.use(Statistic)
Vue.use(Print)
Vue.use(Tooltip)

export default {
  components: {
    [Input.name]: Input,
    SelectLocation,
    [Select.name]: Select,
    [Option.name]: Option,
    MessageBox,
    [Checkbox.name]: Checkbox,
  },

  data() {
    const userData = store.getters.user && store.getters.user.data;
    const uid = (userData && userData.uid) || 'anon';
    const storageKey = `ket.constructionDefects.filters.${uid}`;
    let saved = { parcours: [], prio: [], status: [], showCompleted: false };
    try {
      const raw = localStorage.getItem(storageKey);
      if (raw) {
        const parsed = JSON.parse(raw);
        saved = {
          parcours: Array.isArray(parsed.parcours) ? parsed.parcours : [],
          prio: Array.isArray(parsed.prio) ? parsed.prio : [],
          status: Array.isArray(parsed.status) ? parsed.status : [],
          showCompleted: !!parsed.showCompleted,
        };
      }
    } catch (e) {
      console.warn('Konnte gespeicherte Filter nicht laden:', e);
    }
    return {
      loading: true,
      excelLoading: false,
      defects: [],
      showCompleted: saved.showCompleted,
      counterNew: 0,
      counterWIP: 0,
      counterInAcceptance: 0,
      counterDone: 0,
      counterOpen: 0,
      role: store.getters.userrole,
      location: store.getters.userlocation,
      constructionRole: store.getters.constructionRole,
      storageKey,
      savedFilters: {
        parcours: saved.parcours,
        prio: saved.prio,
        status: saved.status,
      },
    };
  },
  computed: {
    filteredDefects() {
      if (this.showCompleted) {
        return this.defects;
      }
      return this.defects.filter(d => d.defectStatus !== 'Erledigt');
    },
    parcoursFilters() {
      const unique = [...new Set(this.defects.map(d => d.defectParcours).filter(p => p !== undefined && p !== null && p !== ''))];
      unique.sort((a, b) => String(a).localeCompare(String(b), 'de'));
      return unique.map(p => ({ text: p, value: p }));
    }
  },
  watch: {
    showCompleted() {
      this.persistFilters();
    },
  },
  created() {
    if(store.getters.constructionRole == "0") {
      MessageBox.alert(
        "Zugriff verweigert.",
        {
          confirmButtonText: "OK",
          type: "error",
          callback: (action) => {
            router.push({ name: 'Overview' })
          },
        }
      );
    } else {
      moment.locale("de");
      this.loadDefects();
      store.watch(
        (state) => state.userlocation,
        () => {
          this.location = store.getters.userlocation;
          this.loadDefects();
        }
      );
    }
  },
  methods: {
    loadDefects() {
      // get defects data from firebase
      const defectsRef = db.collection("constructionDefects");
      defectsRef.where('locationID', '==', this.location).orderBy("Parcours").orderBy("Date", "desc").onSnapshot((snapshotChange) => {
        this.defects = [];
        snapshotChange.forEach((doc) => {
          this.defects.push({
            key: doc.id,
            defectParcours: doc.data().Parcours,
            defectTitle: doc.data().Title,
            defectElement: doc.data().Element,
            defectPrio: doc.data().Prio,
            defectDate: moment(new Date(doc.data().Date.seconds * 1000)).format("DD.MM.yyyy").toString(),
            defectStatus: doc.data().Status,
            defectAssignedTo: doc.data().AssignedTo,
            defectEffort: doc.data().Effort || 1,
            defectEffortActual: doc.data().EffortActual || 0,
            defectEffortTime: this.convertDecimalToTime(doc.data().Effort || 0),
            defectEffortActualTime: this.convertDecimalToTime(doc.data().EffortActual || 0),
            defectManagementNotes: doc.data().ManagementNotes || '',
          });
        });
        this.counterNew = this.defects.filter(x => x.defectStatus == 'Neu').length;
        this.counterWIP = this.defects.filter(x => x.defectStatus == 'In Arbeit').length;
        this.counterInAcceptance = this.defects.filter(x => x.defectStatus == 'Zur Abnahme').length;
        this.counterDone = this.defects.filter(x => x.defectStatus == 'Erledigt').length;
        this.counterOpen = this.defects.filter(x => x.defectStatus != 'Erledigt').length;
        this.loading = false
      });
    },
    showDetails(row, column) {
      if (column.property) {
        router.push({ name: "DefectDetails", params: { defectId: row.key, mode: 'edit' } });
      }
    },
    convertDecimalToTime(decimal) {
      if (decimal === null || decimal === undefined || decimal <= 0) {
        return "00:00";
      }
      const hours = Math.floor(decimal);
      const minutes = Math.round((decimal - hours) * 60);
      return ("0" + hours).slice(-2) + ":" + ("0" + minutes).slice(-2);
    },
    newDefect() {
      router.push({ name: "DefectDetails", params: { mode: 'new' } });
    },
    filterStatus(value, row) {
      return row.defectStatus === value;
    },
    filterPrio(value, row) {
      return row.defectPrio === value;
    },
    filterParcours(value, row) {
      return row.defectParcours === value;
    },
    onFilterChange(filters) {
      // filters ist ein Objekt mit den column-key -> ausgewählte Werte
      if (filters && Object.prototype.hasOwnProperty.call(filters, 'parcours')) {
        this.savedFilters.parcours = filters.parcours || [];
      }
      if (filters && Object.prototype.hasOwnProperty.call(filters, 'prio')) {
        this.savedFilters.prio = filters.prio || [];
      }
      if (filters && Object.prototype.hasOwnProperty.call(filters, 'status')) {
        this.savedFilters.status = filters.status || [];
      }
      this.persistFilters();
    },
    persistFilters() {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify({
          parcours: this.savedFilters.parcours,
          prio: this.savedFilters.prio,
          status: this.savedFilters.status,
          showCompleted: this.showCompleted,
        }));
      } catch (e) {
        console.warn('Konnte Filter nicht speichern:', e);
      }
    },
    updateLocation(loc) {
      this.location = loc
      this.loadDefects()
    },
    async downloadExcel() {
      this.excelLoading = true;
      try {
        const generateReport = httpsCallable(fc, 'constructionreports-generateOpenDefectsExcelReport');
        const result = await generateReport({ locationId: this.location });
        if (result.data && result.data.url) {
          // Trigger download
          const link = document.createElement('a');
          link.href = result.data.url;
          link.download = result.data.name || 'Offene_Maengel.xlsx';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.$notify({
            message: `Excel-Report mit ${result.data.count} Mängeln wurde erstellt.`,
            icon: "fa fa-check-circle",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "success",
            showClose: true,
            timeout: 5000,
          });
        }
      } catch (error) {
        console.error('Excel export error:', error);
        this.$notify({
          message: "Fehler beim Erstellen des Excel-Reports. Bitte erneut versuchen.",
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 10000,
        });
      } finally {
        this.excelLoading = false;
      }
    },
  },
};
</script>
<style>
.el-tag {
  color: white !important;
}
.el-tag--info {
  background-color: blue !important;
}
.hidePrint {
  @media print {
    display: none;
  }
}
.defect-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.defect-stat-item {
  flex: 1 1 auto;
  min-width: 0;
}
.defect-stat-item .el-statistic .el-statistic__head {
  white-space: nowrap;
}
</style>
